'use client';

import { FallbackImage } from "@/components/common";
import { useEffect, useRef } from "react";

type Props = {
  fullscreenImage: string | null;
  fullscreenWidth: number;
  fullscreenHeight: number;
  closeModal: () => void;
};

export default function FullscreenModal({
  fullscreenImage,
  fullscreenWidth,
  fullscreenHeight,
  closeModal,
}: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (dialogRef.current) {
      if (fullscreenImage) {
        dialogRef.current.showModal();
      } else {
        dialogRef.current.close();
      }
    }
  }, [fullscreenImage]);

  // Si no hay imagen en fullscreen, no renderizamos nada.
  if (!fullscreenImage) return null;

  return (
    <dialog ref={dialogRef} onClose={closeModal} className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-90">
      <button
        className="absolute top-5 right-5 text-white text-3xl font-bold cursor-pointer z-[1000] hover:text-gray-300"
        onClick={closeModal}
      >
        ×
      </button>
      <div className="flex items-center justify-center ">
        <FallbackImage
          src={fullscreenImage}
          alt="Imagen en pantalla completa"
          fill
          className="justify-center object-contain"
          sizes="100vw"
        />
      </div>
    </dialog>
  );
}
